// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"997c8a9b","149":"e543c713","796":"70e07941"}[chunkId] + ".chunk.css";
};